import { Flex } from '@chakra-ui/react';
import { JobItem } from './JobItem';
import { useSubscriber } from '@texas/messageBus/useMessageBus';
import { ServerStatePoll } from '@texas/messageBus/messages';
import { useState } from 'react';
import { JobRecord } from '@texas/api/endpoints/jobRecordsApi';

export function JobList() {
  const [jobs, setJobs] = useState<JobRecord[]>([]);

  useSubscriber(ServerStatePoll, (data) => {
    setJobs(data.data.runningJobs);
  });
  return (
    <Flex flexDir="column" gap={1}>
      {jobs.map((x) => (
        <JobItem key={x.id} job={x} />
      ))}
    </Flex>
  );
}
